import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function CloseCircleIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="CloseCircleIcon" className={clsx(undefined, "Icon", className)} fill="none">
            <path
                d="M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z"
                stroke="#000000"
                strokeWidth="2"
            />
            <path d="M9 9L15 15M15 9L9 15" stroke="#000000" strokeWidth="2" strokeLinecap="round" />
        </SvgIcon>
    );
}
